module.exports = __webpack_public_path__ + "static/media/img04.d5f91a7a.jpg";